import React from 'react';
import './Contact.css';
import { FiGithub, FiLinkedin, FiMail, FiPhone, FiCopy } from 'react-icons/fi';
import { FaFigma } from 'react-icons/fa';
import { useLanguage } from '../../i18n/LanguageContext';

const socialLinks = [
  {
    id: 'github',
    icon: FiGithub,
    url: 'https://github.com/SamyuMT',
    title: 'GitHub'
  },
  {
    id: 'figma',
    icon: FaFigma,
    url: 'https://www.figma.com/@sammt1',
    title: 'Figma'
  },
  {
    id: 'linkedin',
    icon: FiLinkedin,
    url: 'https://www.linkedin.com/in/jereminth-mu%C3%B1oz-de-la-torre/',
    title: 'LinkedIn'
  }
];

const Contact = () => {
  const { t } = useLanguage();

  return (
    <section className="contact" data-name="Contact me" data-node-id="5:728">
      <div className="contact__container" data-name="Container" data-node-id="5:729">
        {/* Header */}
        <div className="contact__header" data-name="Row" data-node-id="5:730">
          <div className="contact__header-inner" data-name="Row" data-node-id="5:731">
            <div className="contact__tag" data-name="Tag" data-node-id="5:732">
              <p className="contact__tag-text">{t('contact.tag')}</p>
            </div>
          </div>

          <div className="contact__header-subtitle" data-name="Row" data-node-id="5:733">
            <p className="contact__subtitle" data-node-id="5:734">
              {t('contact.subtitle')}
            </p>
          </div>
        </div>

        {/* Contact Methods */}
        <div className="contact__methods" data-name="Column" data-node-id="5:735">
          {/* Email */}
          <div className="contact__method" data-name="Email" data-node-id="5:736">
            <div className="contact__method-icon">
              <FiMail size={32} color="#4b5563" />
            </div>
            <a 
              href="mailto:jemycraft12@hotmail.com"
              className="contact__method-text contact__method-text--link" 
              data-node-id="5:738"
            >
              jemycraft12@hotmail.com
            </a>
            <button 
              className="contact__method-btn" 
              title="Copy email" 
              data-node-id="5:739"
              onClick={() => navigator.clipboard.writeText('jemycraft12@hotmail.com')}
            >
              <FiCopy size={24} color="#4b5563" />
            </button>
          </div>

          {/* Phone */}
          <div className="contact__method" data-name="Phone" data-node-id="5:740">
            <div className="contact__method-icon">
              <FiPhone size={32} color="#4b5563" />
            </div>
            <a 
              href="tel:+573024946753"
              className="contact__method-text contact__method-text--link" 
              data-node-id="5:742"
            >
              +57 3024946753
            </a>
            <button 
              className="contact__method-btn" 
              title="Copy phone" 
              data-node-id="5:743"
              onClick={() => navigator.clipboard.writeText('+57 3024946753')}
            >
              <FiCopy size={24} color="#4b5563" />
            </button>
          </div>
        </div>

        {/* Social Links */}
        <div className="contact__social" data-name="Row" data-node-id="5:744">
          <div className="contact__social-content" data-name="Social" data-node-id="5:745">
            <p className="contact__social-text" data-node-id="5:746">
              {t('contact.findMe')}
            </p>

            <div className="contact__social-container" data-name="Actions" data-node-id="5:747">
              <div className="contact__social-links" data-name="Links" data-node-id="5:748">
                {socialLinks.map((social) => {
                  const IconComponent = social.icon;
                  return (
                    <a
                      key={social.id}
                      href={social.url}
                      className="contact__social-btn"
                      title={social.title}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <IconComponent size={24} color="#4b5563" />
                    </a>
                  );
                })}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contact;
